import React from 'react';
import Layout from '../../components/Layout';
import HeroWithVideo from '../../components/shared/HeroWithVideo';
import HeroContent from './HeroContent';
import TwoColumnMeasurementSummary from './TwoColumnMeasurementSummary';

const Architects = () => (
  <Layout
    isNavInitiallyTransparent={false}
    title="Measurement App for Architects | Home Improvement"
    description="Get detailed, accurate exterior measurements with the HOVER app, which transforms smartphone photos into a 3D model of any home."
  >
    <HeroWithVideo
      heroContent={<HeroContent />}
      videoTitle="HOVER - For Architects Video"
      videoUrl="https://fast.wistia.net/embed/iframe/qmwwtfpw6u?autoplay=1"
    />
    <TwoColumnMeasurementSummary />
  </Layout>
);

export default Architects;
